import clsxm from "@/lib/clsxm"

import { ServiceItem } from "./item"
import ServicesDivider from "../../../public/svg/homepage/services-divider.svg"

export const Services = () => {
  return (
    <section
      className={clsxm(
        `relative flex flex-col items-center justify-center bg-gray-900 pb-20`
      )}
    >
      <ServicesDivider
        className={clsxm(
          `absolute top-10 left-0 max-h-full w-full`,
          `sm:-top-px`
        )}
      />

      <div
        className={`w-full max-w-6xl px-4 sm:grid sm:grid-cols-12 sm:justify-between`}
      >
        <div
          className={clsxm(
            `mx-auto grid w-full auto-rows-[1fr] grid-cols-2 gap-2`,
            `sm:col-span-12 sm:col-start-1 sm:grid-cols-3 sm:gap-4`,
            `md:col-span-10 md:col-start-2 md:grid-cols-3 md:gap-4`,
            `before:col-start-1 before:col-end-1 before:row-start-1 before:row-end-1 before:block before:w-0 before:pb-[100%]`
          )}
        >
          <ServiceItem
            heading={`Acupuncturists`}
            imageUrl={`/images/homepage/services/acupuncture.png`}
            imageAltText={`Person being treated with acupuncture`}
            specialty={`acupuncture`}
            text={`Place needles in your skin at strategic points on your body to simulate nerves, muscles and connective tissue.`}
          />
          <ServiceItem
            heading={`Chiropractors`}
            imageUrl={`/images/homepage/services/chiropractic.png`}
            imageAltText={`Person being treated with chiropractic`}
            specialty={`chiropractic`}
            text={`Focus on disorders of the musculoskeletal & nervous systems and effects of these disorders by adjusting or manipulating the spine.`}
          />
          <ServiceItem
            heading={`Hand Therapists`}
            imageUrl={`/images/homepage/services/handtherapist.png`}
            imageAltText={`Person being treated with hand therapy`}
            specialty={`hand_therapy`}
            text={`Specialises in injuries and conditions from the elbow down to the fingers. they are registered physiotherapist and occupational therapists.`}
          />
          <ServiceItem
            heading={`Massage Therapists`}
            imageUrl={`/images/homepage/services/massage.png`}
            imageAltText={`Person being treated with massage`}
            specialty={`massage`}
            text={`Sit within the wellness model and aim to support clients in balancing mental, emotional, and physical needs.`}
          />
          <ServiceItem
            heading={`Osteopaths`}
            imageUrl={`/images/homepage/services/osteopathy.png`}
            imageAltText={`Person being treated with osteopathy`}
            specialty={`osteopathy`}
            text={`Uses a variety of techniques to help correct physical conditions, may include manipulation of the joints soft tissues and stretches.`}
          />
          <ServiceItem
            heading={`Physiotherpists`}
            imageUrl={`/images/homepage/services/physiotherapy.png`}
            imageAltText={`Person being treated with physiotherapy`}
            specialty={`physiotherapy`}
            text={`Help restore movement and function for injury, disability, and function for injury, disability, and general health conditions may include manual therapies and exercise.`}
          />
          <ServiceItem
            heading={`Podiatrists`}
            imageUrl={`/images/homepage/services/podiatry.png`}
            imageAltText={`Person being treated with podiatry`}
            specialty={`podiatry`}
            text={`Are of the foot and treat conditions which affect the skin, nails, muscles, joints, tendons, nerves and circulation of the foot.`}
          />
        </div>
      </div>
    </section>
  )
}
